import React, { useCallback, useEffect, useState } from 'react'
// import PcosRiskCheck from '../components/PCOSRiskScreening/WelcomeScreen'
import styles from './PCOSRiskScreen.module.css';
// import { ConsentScreen } from './HealthAssessmentJourney';
import GenericScreen from '../components/HealthAssessment/GenericScreen';
import data from '../components/PCOSRiskScreening/PCOSRisk.json'
import ReviewSubmitScreen from '../components/HealthAssessment/ReviewSubmitScreen';
import ResultsScreen from '../components/HealthAssessment/ResultsScreen';
// import { computeScore } from '../utils/scoreUtils';
import ViewResults from '../components/HealthAssessment/ViewSummary';
import WelcomeScreen from '../components/PCOSRiskScreening/WelcomeScreen';
import ConsentScreenPCOS from '../components/PCOSRiskScreening/ConsentScreenPCOS';
import WelcomeScreenPCOS from '../components/PCOSRiskScreening/WelcomeScreen';
import { maxScoreForQ, SCORE_RANGES } from './PregnancyRiskScreening';
// import { computeScore } from './PregnancyRiskScreening';
// import pcosData from '../components/PCOSRiskScreening/PCOSRiskScreeningData.json';

const screens = {
    1: "start",
    2: "consent",
    3: "pcosRiskScreen",
    4: "reviewSummary",
    5: "riskResult",
    6: "nextAction"
};



// ─── Constants ───────────────────────────────────────────────────────────────
const ALL_QUESTIONS = data.questions;

const RED_FLAG_IDS = new Set([
    // PCOS has no hard red flags, add any if needed
]);


const rangeFromPct = (pct) =>
    SCORE_RANGES.find((r) => pct >= r.min && pct <= r.max) ?? SCORE_RANGES.at(-1);


const SKIP_GROUPS = new Set(['fertility_context']);
export const computeScore = (allAnswers) => {
    if (!allAnswers || Object.keys(allAnswers).length === 0) return null;
    console.log(allAnswers, "this is allanswers")
    const SCREENING_KEY = "Pregnancy Risk Screening";
    // const flat = allAnswers[SCREENING_KEY] ?? {};
    const flat = allAnswers?.[data.title] ?? {};

    const SKIP_GROUPS = new Set(['pregnancy_confirmation', 'fertility_context']);
    const RED_FLAG_WEIGHT = 20;

    let raw = 0;
    let maxPossible = 0;
    const redFlags = [];

    ALL_QUESTIONS.forEach((q) => {
        if (SKIP_GROUPS.has(q.group)) return;

        const answer = flat[q.id];  // { value, score }

        if (RED_FLAG_IDS.has(q.id)) {
            const fired = answer?.value === 'yes';
            raw += fired ? RED_FLAG_WEIGHT : 0;
            maxPossible += RED_FLAG_WEIGHT;
            if (fired) redFlags.push(q.label);
            return;
        }

        const score = answer?.score ?? 0;
        const max = maxScoreForQ(q);
        raw += score;
        maxPossible += max;

        console.log(`q="${q.id}" value="${answer?.value}" score=${score}/${max}`);
    });

    const percent = maxPossible > 0 ? Math.round((raw / maxPossible) * 100) : 0;
    const range = rangeFromPct(percent);

    console.log(`TOTAL: ${raw}/${maxPossible} = ${percent}% → "${range.label}"`);

    return {
        raw,
        max: maxPossible,
        percent,
        label: range.label,
        color: range.color,
        risk: range.risk,
        ranges: SCORE_RANGES,
        redFlags,
        redFlagNote: redFlags.length > 0
            ? `⚠️ ${redFlags.length} red flag${redFlags.length > 1 ? 's' : ''} detected — consult a doctor promptly.`
            : null,
    };
};
const PCOSRiskScreen = () => {
    const [screen, setScreen] = useState("start");
    const [allAnswers, setAllAnswers] = useState({});
    const [openLastQuestion, setOpenLastQuestion] = useState(false);
    // 1. Add targetStepIndex state
    const [targetStepIndex, setTargetStepIndex] = useState(null)
    const [assessmentType, setAssessmentType] = useState(null);
    const goTo = (s, options = {}) => {
        setOpenLastQuestion(!!options.openLastQuestion);
        setTargetStepIndex(options.targetStepIndex ?? null);
        setScreen(s);
        window.scrollTo(0, 0);
    };
    
    const buildPcosSections = (screenConf) => {
        const groupMap = new Map();
        let idx = 0;
        (screenConf.questions || []).forEach((q) => {
            const key = q.group || q.id;
            if (!groupMap.has(key)) {
                groupMap.set(key, {
                    step: idx,   // ← numeric index, onEdit receives this
                    label: q.group
                        ? q.group.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
                        : q.label,
                });
                idx++;
            }
        });
        return Array.from(groupMap.values());
    };

    const screenEntries = Object.entries(screens);
    const screenConf = data;

    const handleGoNext = () => {
        const currentIndex = screenEntries.findIndex(([, value]) => value === screen);
        if (currentIndex < screenEntries.length - 1) {
            goTo(screenEntries[currentIndex + 1][1]);
        }
    };

    const handleGoBack = () => {
        const currentIndex = screenEntries.findIndex(([, value]) => value === screen);
        if (currentIndex > 0) {
            goTo(screenEntries[currentIndex - 1][1]);
        }
    };

    // const updateAnswer = useCallback((screenTitle, field, value) => {
    //     setAllAnswers((prev) => ({
    //         ...prev,
    //         [screenTitle]: { ...(prev[screenTitle] || {}), [field]: value }
    //     }));
    // }, []);
        const updateAnswer = useCallback((screenTitle, field, value, score) => {
        setAllAnswers((prev) => ({
            ...prev,
            [screenTitle]: {
                ...(prev[screenTitle] || {}),
                [field]: { value, score: score ?? 0 }  // ✅ { value, score } object
            }
        }));
    }, []);
    
useEffect(()=>{
    console.log("all answers",allAnswers)
}, [allAnswers])
    const makeChangeHandler = (screenTitle) => (field, value,score) => {
        updateAnswer(screenTitle, field, value,score);
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.cardPC}>
                <div className={styles.card}>
                    {screen === "start" && (
                        <WelcomeScreenPCOS onNext={() => goTo("consent")} />
                    )}
                    {screen === "consent" && (
                        // <ConsentScreenPCOS
                        //     onNext={() => goTo('pcosRiskScreen')}
                        //     onBack={() => goTo('start')}
                        //     showPageWrap={false}
                        // />
                        <ConsentScreenPCOS
  title="Before we begin"
  description={[
    'This screening is for informational purposes only and not a medical diagnosis.',
    'Please confirm that you understand and consent to proceed.',
  ]}
  checkLabel="I agree that this screening does not replace professional medical advice, diagnosis or treatment."
  step={1}
  totalSteps={10}
  ctaLabel="I agree, continue"
  onBack={() => goTo('start')}
  onAgree={() => goTo('pcosRiskScreen')}
/>
 
                    )}

                    {screen === 'pcosRiskScreen' && (
                        <div className={styles.cardFixedLayout}>
                            <GenericScreen
                                initialStepIndex={targetStepIndex}
                                openLastQuestion={openLastQuestion}
                                screenConfig={screenConf}
                                data={allAnswers?.[screenConf.title] || {}}
                                onChange={makeChangeHandler(screenConf.title)}
                                onNext={() => goTo('review')}

                                onBack={() => goTo('consent')}
                            />
                        </div>
                    )}

                    {screen === 'review' && (
                        <ReviewSubmitScreen
                            allAnswers={allAnswers}
                            onEdit={(stepIdx) => goTo('pcosRiskScreen', { targetStepIndex: stepIdx })}
                            onSubmit={() => goTo('results')}
                            onBack={() => goTo('pcosRiskScreen', { openLastQuestion: true })}
                            customSections={buildPcosSections(screenConf)}
                            assessmentType={"PCOS Risk"}
                        />
                    )}
                    {screen === 'results' && (
                        <ResultsScreen
                            answers={allAnswers}
                            assessmentType={"PCOS Risk "}
                            goTo={() => goTo('viewSummary')}
                            scoreResult={computeScore(allAnswers)}
                            onBack={() => goTo('review')}
                        />
                    )}
                    {screen === 'viewSummary' && (
                        <ViewResults
                            answers={allAnswers}
                            assessmentType={assessmentType}
                            onBack={() => goTo('results')}

                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default PCOSRiskScreen;